module.exports = __webpack_public_path__ + "img/24-3.638603f0.png";